import Tools from '../../tools/tools';

export default class Success{
	constructor(view){
		console.log('Success :: init',view);

		this.view 		= view;
		this.lang		= document.documentElement.getAttribute('lang');

		this.cardBrand	= "";
		this.card4LastNumb = 0;
	}

	load(formData){
		Tools.scrollTo(0,$(document.querySelector('#vipForm')).offset().top - 40);
		console.log("RECEIPT: ", formData);

		let user_id 	= this.view.querySelector('.user_id strong'),
			trans_date 	= this.view.querySelector('.trans_date strong'),
			cardBrand 	= this.view.querySelector('.cardbrand'),
			cardLast4 	= this.view.querySelector('.cardlast4 strong'),
			customer 	= this.view.querySelector('.customer'),
			billing 	= this.view.querySelector('.billing');

		let time = formData.transaction.date;
		let timeSplit = time.split(' ');

		user_id.innerHTML 		= formData.transaction.id;
		trans_date.innerHTML 	= timeSplit[1];
		cardBrand.innerHTML 	= this.cardBrand;
		cardLast4.innerHTML 	= "**** " + this.card4LastNumb;

		let pC = document.createElement('p');
		let	firstC = pC.cloneNode(true);
		let	companyC = pC.cloneNode(true);
		let secondC = pC.cloneNode(true);
		let thirdC = pC.cloneNode(true);
		let fourthC = pC.cloneNode(true);
		let fifthC = pC.cloneNode(true);

		let appC = formData.customer.appartement ? ", " + formData.customer.apartement : "";
		let company = formData.customer.company ? formData.customer.company : "";

		firstC.innerHTML = formData.customer.name;
		if(company) companyC.innerHTML = company;
		secondC.innerHTML = formData.customer.address +  appC;
		thirdC.innerHTML = formData.customer.city + ", " + formData.customer.province + ", "+ formData.customer.country + ", " + formData.customer.zipcode ;
		fourthC.innerHTML = formData.customer.phone;
		fifthC.innerHTML = formData.customer.email;

		customer.querySelector('address').appendChild(firstC);
		if(company) customer.querySelector('address').appendChild(companyC);
		customer.querySelector('address').appendChild(secondC);
		customer.querySelector('address').appendChild(thirdC);
		customer.querySelector('address').appendChild(fourthC);
		customer.querySelector('address').appendChild(fifthC);
	}

}